import { encode as base64_encode, decode as base64_decode } from "base-64";

import { postApi } from "../components/Utility";
import { action, makeObservable, observable } from "mobx";
import moment from "moment";
import config from "../config";
import Cookies from "js-cookie";

class TrackingDashboardStore {
  total = 0;
  loading = false;
  trackData = [];
  geofenceData = [];
  vehicalState = [];
  usageGraphData = [];
  totalvehstate = [];
  livetrack = [];
  totalvehiclestate = [];
  notificationData = [];

  rootStore;

  constructor(rootStore) {
    makeObservable(this, {
      trackData: observable,
      loading: observable,
      notificationData: observable,
      loadData: action,
      getGeofenceData: action,
      getUsageGraph: action,
      getMaxSpeedGraph: action,
      getNotificationData: action,
    });
    this.rootStore = rootStore;
  }

  async loadData({ offset, limit, companyId, status }) {
    this.loading = true;

    const base64Input = await base64_encode(JSON.stringify(postData));
    if (config.pythonReport === 1) {
      var postData = {
        companyId: companyId,
        userCompany: 1,
        status: status,
        offset: offset,
        isadmin: -1,
        limit: limit //500,
      };

      var response = await postApi.getClient("").get(config.NodeUrl + "/DetailTracking/getDetailtrackDataByCH", { params: postData });


      var liveTrackingData = response?.data?.data?.detailtrack;
      var totalCount = response?.data?.data?.TotalCount;
      this.vehicalState = response?.data?.data?.totalvehstate;
      this.total = parseInt(Number(response?.data?.data?.totalvehstate.actualTotalCount));

      let finalLiveTrackingData = await this.handleVehicleImageCH(liveTrackingData);
      this.trackData = finalLiveTrackingData

      //var response = await postApi.getClient("").get("http://localhost:3059/DetailTracking/getDetailtrackDataByCH", { params: postData });
    }
    else {
      var postData = {
        companyId: companyId,
        userCompany: 1,
        vehicleStatus: status,
        offset: offset,
        isadmin: -1,
        limit: limit //500,
      };

      var response = await postApi.getClient().post("index.php?c=vehicletracking&a=getDetailTrackDashboard", "postData=" + base64Input);

      var liveTrackingData = response?.data?.data?.detailtrack;
      var totalCount = response?.data?.data?.TotalCount;
      if (liveTrackingData && Number(totalCount) > 0) {
        Object.keys(liveTrackingData).map((e, i) => {
          let r = liveTrackingData[i];

          //  var diff = new Date(r.currtime) - new Date(r.updatedate);
          const diff = moment(r.currtime).diff(r.updatedate, "minutes");
          var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
          if (diff >= 90) {
            liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
            liveTrackingData[i].rowBackground = "gray";
            liveTrackingData[i].currentStatus = "nodata";
          } else if (r.acc == 1 && r.speed == 0) {
            //idle)
            liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
            liveTrackingData[i].rowBackground = "yellow";
            liveTrackingData[i].currentStatus = "idle";
          } else if (r.acc == 0) {
            liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
            liveTrackingData[i].rowBackground = "red";
            liveTrackingData[i].currentStatus = "stop";
          } else if (r.acc == 1 && r.speed > 0) {
            liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
            liveTrackingData[i].rowBackground = "green";
            liveTrackingData[i].currentStatus = "running";
          }
          liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

          try {
            require("../assets/images/detailtracking/" +
              liveTrackingData[i].listImage);
          } catch (err) {
            liveTrackingData[i].listImage = "car-icon-blue.png";
          }

          try {
            require("../assets/images/livetracking/" +
              liveTrackingData[i].mapImage);
          } catch (err) {
            liveTrackingData[i].mapImage = "car-icon-blue.png";
          }
        });

        this.trackData = liveTrackingData;

        this.vehicalState = response?.data?.data?.totalvehstate;

        //this.total = parseInt(Number(response?.data?.data?.TotalCount));
        this.total = parseInt(Number(response?.data?.data?.totalvehstate.actualTotalCount));
      }




    }

    this.loading = false;
  }


  async handleVehicleImageCH(data) {
    let liveTrackingData = data;
    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];
      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      let defaultImage = "car-icon-blue.png";
      if (r.vehicleStatus === "nodata") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "No Data";
        defaultImage = "default-gray.png";
      } else if (r.vehicleStatus === "idle") {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "Idle";
        defaultImage = "default-yellow.png";
      } else if (r.vehicleStatus === "stop") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "Stopped";
        defaultImage = "default-red.png";
      } else if (r.vehicleStatus === "running") {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "Running";
        defaultImage = "default-green.png";
      }

      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = defaultImage;
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = defaultImage; //"car-icon-blue.png";
      }
    });
    return liveTrackingData;
  }
  async getGeofenceData({ companyId, status }) {
    this.loading = true;

    var postData = {
      companyId: companyId,
      vehicleId: "All",
      geozoneId: "All",
      offset: "-1",
      fromDate: "2025-06-18 00:00:00",
      toDate: "2025-06-18 23:59:59",
    };

    const base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post("index.php?c=vehicle&a=geofenceinout", "postData=" + base64Input);

    this.geofenceData = response?.data?.data?.geofenceinout;

    this.loading = false;
  }

  async getLiveRouteData({ companyId, userId, offset, limit, searchField, isadmin }) {
    var postData = {
      companyId: companyId,
      offset: 0,
      limit: 50,
      userId: userId,
      searchField: searchField,
      isadmin: isadmin
    };
    const base64Input = await base64_encode(JSON.stringify(postData));

    if (config.pythonReport === 1) {

      var response = await postApi.getClient("").get(config.NodeUrl + "/liveTracking/getAllLiveTrackingVehiclesCH", { params: postData });
    }
    else {
      var response = await postApi.getClient().post("index.php?c=vehicletracking&a=getLiveRouteData", "postData=" + base64Input);
    }

    //var response = await postApi.getClient("").get("http://localhost:3054/liveTracking/getAllLiveTrackingVehiclesCH", { params: postData });
    //

    var liveTrackingData = response.data?.data?.livetrack;
    Object.keys(liveTrackingData).map((e, i) => {
      let r = liveTrackingData[i];

      //  var diff = new Date(r.currtime) - new Date(r.updatedate);
      const diff = moment(r.currtime).diff(r.updatedate, "minutes");
      var vehicleTypeNew = r.vehicleTypeNew?.split(" ").join("-");
      if (diff >= 90) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-gray.png";
        liveTrackingData[i].rowBackground = "gray";
        liveTrackingData[i].currentStatus = "nodata";
      } else if (r.acc == 1 && r.speed == 0) {
        //idle)
        liveTrackingData[i].listImage = vehicleTypeNew + "-yellow.png";
        liveTrackingData[i].rowBackground = "yellow";
        liveTrackingData[i].currentStatus = "idle";
      } else if (r.acc == 0) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-red.png";
        liveTrackingData[i].rowBackground = "red";
        liveTrackingData[i].currentStatus = "stop";
      } else if (r.acc == 1 && r.speed > 0) {
        liveTrackingData[i].listImage = vehicleTypeNew + "-green.png";
        liveTrackingData[i].rowBackground = "green";
        liveTrackingData[i].currentStatus = "running";
      }
      liveTrackingData[i].mapImage = liveTrackingData[i].listImage;

      try {
        require("../assets/images/detailtracking/" +
          liveTrackingData[i].listImage);
      } catch (err) {
        liveTrackingData[i].listImage = "car-icon-blue.png";
      }

      try {
        require("../assets/images/livetracking/" +
          liveTrackingData[i].mapImage);
      } catch (err) {
        liveTrackingData[i].mapImage = "car-icon-blue.png";
      }
    });

    this.livetrack = liveTrackingData;

    this.totalvehiclestate = response.data?.data?.totalvehstate;
  }

  async getUsageGraph({ companyId, currentDate }) {

    const userData = JSON.parse(base64_decode(Cookies.get("data")));

    var postData = {
      companyId: companyId,
      userId: userData.userId,
      isadmin: userData.isadmin,
      fromDate: currentDate,
      toDate: currentDate,
      offset: 0,
      limit: 10,
      isGraph: true,
    };
    var base64Input = await base64_encode(JSON.stringify(postData));

    if (config.pythonReport === 1) {
      var response = await postApi.getClient("report").post("fleet_report/fleetDaySummary", postData);
    }
    else {
      var response = await postApi.getClient().post("index.php?c=vehicle&a=usageGraphDashboard", "postData=" + base64Input);
    }

    if (config.pythonReport === 1) {
      var data = response?.data?.data?.daysummary;
    }
    else {
      var data = response?.data?.data?.usagedata;
    }

    if (data && data) {
      data.forEach((element, index) => {
        element.TotalTravelDistance = parseFloat(element.TotalTravelDistance);
      });
    }

    this.usageGraphData = data;

    return response?.data?.data?.usagedata;
  }

  async getNotificationData(companyId) {
    var postData = { companyId: companyId };
    var base64Input = await base64_encode(JSON.stringify(postData));
    var response = await postApi
      .getClient()
      .post(
        "index.php?c=user&a=getNotificationDashboard",
        "postData=" + base64Input
      );

    this.notificationData = response.data.data;
  }

  async getMaxSpeedGraph({ companyId, maxspeed, currentDate }) {

    const userData = JSON.parse(base64_decode(Cookies.get("data")));

    var postData = {
      companyId: companyId,
      userId: userData.userId,
      isadmin: userData.isadmin,
      type: maxspeed,
      dashboardMAxSpeedGraph: 1,
      fromDate: currentDate,
      toDate: currentDate,
      offset: 0,
      limit: 50
    };
    var base64Input = await base64_encode(JSON.stringify(postData));

    if (config.pythonReport === 1) {
      var response = await postApi.getClient("report").post("graph/maxspeedGraph", postData);
    } else {
      var response = await postApi.getClient().post("index.php?c=vehicle&a=maxSpeedGraphDashboard", "postData=" + base64Input);
    }


    var maxSpeedGraphData = response?.data?.data?.MaxSpeedGraph;
    if (maxSpeedGraphData && maxSpeedGraphData) {
      maxSpeedGraphData.forEach((element) => {
        // Convert specific properties to floats
        element.maxSpeed = parseFloat(element.maxSpeed);
      });
    }
    this.maxSpeedGraph = response?.data?.data?.MaxSpeedGraph;
    return response?.data?.data?.MaxSpeedGraph;
  }

  async getDistanceGraph({ companyId, distance, currentDate, isGraph }) {

    const userData = JSON.parse(base64_decode(Cookies.get("data")));

    var postData = {
      companyId: companyId,
      userId: userData.userId,
      isadmin: userData.isadmin,
      type: distance,
      fromDate: currentDate,
      toDate: currentDate,
      dashboardDistanceGraph: 1,
      offset: 0,
      limit: 50,
      isGraph: isGraph,
    };
    var base64Input = await base64_encode(JSON.stringify(postData));

    if (config.pythonReport === 1) {
      console.log("🔗 Calling Python API: /graph/distanceGraph");

      var response = await postApi.getClient("report").post("tracking_report/distancereport", postData);
      console.log(response, "response")
    }
    else {
      var response = await postApi.getClient().post("index.php?c=vehicle&a=maxSpeedGraphDashboard", "postData=" + base64Input);
    }



    if (config.pythonReport === 1) {
      var distanceGraphData =
        response?.data?.data?.distanceReport ||
        response?.data?.data?.distanceReport ||
        [];
    }
    else {
      var distanceGraphData = response?.data?.data?.distancegraph;
    }


    if (distanceGraphData && distanceGraphData) {
      distanceGraphData.forEach((element) => {
        // Convert specific properties to floats
        element.distanceTravel = parseFloat(element.distanceTravel);
      });
    }
    // this.distaceGraph = response?.data?.data?.distancegraph;
    this.distaceGraph = distanceGraphData;
    return response?.data?.data?.distancegraph;
  }

  async exportExcel(getData) {
    window.location.href =
      config.baseURL +
      "index.php?c=vehicletracking&a=exportDetailTrackingExcel&cid=" +
      getData.companyId +
      "&isadmin=" +
      getData.isadmin +
      "&userId=" +
      getData.userId +
      "&colList=" +
      getData.colList +
      "&searchField=" +
      getData.searchField +
      "&status=" +
      getData.status;
  }
}

export default TrackingDashboardStore;
